import { call, put, take } from 'redux-saga/effects';

import { handleSagaError } from '»utils/handleSagasError';

import { tracerSlice } from './_tracer.slice';
import { tracerServices } from './tracer.services';

const tracerWorker = function* ({ loginId, optionId }) {
  try {
    const data = yield call(tracerServices.trace, { loginId, optionId });
    tracerServices.updateTraceInfo({ trackingId: data['sallo-id'], optionId });
    yield put(tracerSlice.actions.tracerSuccess());
  } catch (error) {
    const handled = yield call(handleSagaError, error);
    if (!handled) yield put(tracerSlice.actions.tracerFailure(error));
  }
};

export const tracerSagas = function* () {
  while (true) {
    try {
      const data = yield take(tracerSlice.actions.tracerRequest.type);
      const { loginId, optionId } = data.payload;
      yield call(tracerWorker, { loginId, optionId });
    } catch (error) {
      yield put(tracerSlice.actions.tracerFailure(error));
    }
  }
};
